<template>
  <div class="results">
<h1>Demo</h1>
<b-table hover :items="demos"></b-table>
<h1>Test</h1>
<b-table hover :items="measurements"></b-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'results',
  computed: mapState([
    'lang','demos','measurements'
  ]),
  mounted () {
    console.log(this.lang)
    console.log(this.demos)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/components/Results.vue